import {
	ClientOnly,
	createFileRoute,
	useNavigate,
	useSearch,
} from '@tanstack/react-router'
import { LoginProcess } from '@/components/login-process'
import { Button } from '@/components/ui/button'
import { useWalletConnection } from '@/hooks/useWalletConnection'
import { useAuthStore } from '@/stores/authStore'
import {useEffect, useCallback} from 'react'

type HomeSearch = {
	redirect?: string
}

export const Route = createFileRoute('/')({
	component: Home,
	validateSearch: (search: Record<string, unknown>): HomeSearch => {
		return {
			redirect: search.redirect as string,
		}
	},
})

function Home() {
	const { updateUserInfo, isConnected } = useWalletConnection()
	const { status } = useAuthStore((state) => state.auth)
	const navigate = useNavigate()
	const { redirect } = useSearch({from: '/',})

	const handleLoginSuccess = useCallback(() => {
		updateUserInfo()
		if (redirect) {
			navigate({
				to: redirect,
			})
		} else {
			navigate({
				to: '/dashboard',
			})
		}
	}, [updateUserInfo, redirect, navigate])

	// Only redirect if wallet is connected AND user is fully authenticated (SIWE completed)
	useEffect(() => {
		if (isConnected && status === 'authenticated') {
			handleLoginSuccess()
		}
	}, [])
	// }, [isConnected, status, handleLoginSuccess])

	return (
		<ClientOnly
			fallback={
				<div className="flex flex-col items-center justify-center gap-10 p-2 min-h-svh">
					<div className="flex flex-col items-center gap-4">
						<h1 className="text-3xl font-bold sm:text-4xl">GaiaDEX</h1>
					</div>
					<Button size="lg" className="w-fit" disabled>
						App Loading…
					</Button>
				</div>
			}
		>
			<LoginProcess onSuccess={handleLoginSuccess} />
		</ClientOnly>
	)
}
